<!-- <div class="header-container">
  <img
    width="80"
    style="vertical-align: middle;"
    alt="Angular Logo"
    src="assets/bio-image.jpeg"
  />

  <span class="header-title">Vishwanathph.in</span>
</div>

<div class="ui-grid">
  <div class="ui-grid-col-4">Col1</div>
  <div class="ui-grid-col-4">Col2</div>
  <div class="ui-grid-col-4">Col2</div>
</div> -->
<div class="p-grid p-align-center">
  <img class="p-col-1" alt="Angular Logo" src="assets/bio-image2.jpeg" />
  <span class="header-title p-col-3">Vishwanathph</span>
  <div class="p-col-6">
    <!-- <div>
      <span class="communications-title p-col-1">Contact :</span>
      <span class="communications-title p-col-1"
        >vishwanathph@gmail.com / 7022033694</span
      >
    </div> -->

    <div class="contacts">
      <span class="p-col-2 fa fa-whatsapp"> </span>
      <span class="whatsapp">8105233694 </span> |

      <span class="p-col-2 fa fa-phone" aria-hidden="true"></span>
      <span class="phone">8105233694 </span> |

      <span class="p-col-2 fa fa-envelope" aria-hidden="true"></span>
      <span class="email">vishwanathph@gmail.com </span>
    </div>
  </div>
  <div class="p-col-2 communucations">
    <div>
      <span class="communications-title p-col-2"></span>
      <a
        href="https://www.facebook.com/vishwanath.ph.7"
        class="fa fa-facebook p-col-1"
        target="_blank"
      ></a>
      <a
        href="https://github.com/vish-git"
        class="fa fa-github p-col-1"
        target="_blank"
      ></a>
      <a
        href="https://www.linkedin.com/in/vishwanath-ph/"
        class="fa fa-linkedin p-col-1"
        target="_blank"
      ></a>
    </div>
  </div>
</div>
